<script lang="ts">
	import Accordion from "./Accordion.svelte";
	import {Utils} from "./util";
	import type {TranslatedString} from "./model";
    import {createEventDispatcher, onMount} from "svelte";

	export let rows: {text: TranslatedString, value: boolean, additionalInfo?: TranslatedString | null}[];

    export let imagesLoaded = false;

    let loadCounter = 0;

    $: imagesLoaded = loadCounter == (rows?.length || 0);

    onMount(() => loadCounter = 0);
    function imageLoaded() {
        loadCounter++;
    }
</script>

<div id="questionsContainer">
    {#each rows || [] as row}
        <!-- additionalInfo class hides bottom bar -->
        <div class="table-row"
             class:additionalInfo={row.additionalInfo && Object.keys(row.additionalInfo).length > 0}>
            <div class="question-text">{Utils.chooseTranslation(row.text)}</div>
            <div class="answer-icon-container">
                <img alt="{row.value ? 'yes' : 'no'}" class="icon" on:load={imageLoaded}
                     src={row.value ? "./map/img/confirm_24px.png" : "./map/img/nope_24px.png"}>
            </div>
        </div>
        {#if row.additionalInfo && Object.keys(row.additionalInfo).length > 0}
            <div class="table-row">
                <Accordion content={Utils.chooseTranslation(row.additionalInfo)}/>
            </div>
        {/if}
    {/each}
</div>

<style>
    .answer-icon-container {
        text-align: end;
    }

</style>
